import {
  Form,
  Button,
  Row,
  Col,
  Checkbox,
  Collapse,
  Divider,
  Typography
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Field,
  ChildForm
} from "../../types/field";
import moment from "moment";
import {
  filterNullValues,
  getIndexOfAccessLevel,
  getIndexOfAccessLevelFromVal,
  getIndexOfPlatformAction,
  getIndexOfPlatformActionFromVal
} from "../../utils/utils";
import { AccessLevel, ExtraRecordLevelActions, RowLevelAction, StepAction, platformActionLabelsType } from "../../types/types";
import { Notification } from "../../components/notification/notification";
import CustomRecordDetailModal from "../../components/modal/customRecordDetailModal";
import { apiAliasMapper, dataApiType, dataTypeHandling, evaluateCriteria, evaluateVisibilityOfAction, executeExtraAction, filterNonCreatableFields, filterNonUpdatableFields, getAction, getViewApi, handleLoanNumberLookUp, handleOnBlurOnField, mapCreateApiToAliasNames, mapViewApiToAliasNames, refreshFieldsBasedOnVisibility, refreshFormulaFields } from "./recordDetailUtils";
import RelatedInfo from "../../components/relatedInfo/relatedInfo";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { GetRequest, PostRequest, PutRequest } from "../../utils/api";
// import { onlyNumericRegex, aadhaarPattern, passportRegex, licenseRegex, rationCardRegex, panRegex, emailRegex, voterIdRegex, newInfoMobileRegex } from "../../utils/regex-patterns";
import store from "../../store";
import { deleteDetailsPageData } from "../../states/actions";
import { refineApiWithUrlParams } from "./detailsPageCommonsUtils";
import AutoCompleteHandler from "../../autoCompeleteHandler";
import WholeScreenModal from "../../components/loader/WholeScreenLoader";
// import { splitArray } from "./detailsPagesUtils";
import InputMethods from "./inputFieldRenderMethods";
import { validationMethod } from "./detailsPagesUtils";
const { Panel } = Collapse;
const { Text } = Typography;
interface Props {
  urlparams: Map<string, string>;
  recordId: string;
  platformAction: RowLevelAction;
  createApi: string;
  updateApi?: string;
  dataApi: string;
  dataApiMapper?: apiAliasMapper[];
  dataApis?: dataApiType[];
  createApiMapper?: apiAliasMapper[];
  viewApi?: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  editForm: Field[];
  setOpen: Function;
  dependantFields?: any;
  userAccessLevel: AccessLevel;
  parentEntity?: string;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable?: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  moduleCode: string;
  mulitiDependency?: boolean,
  title?: string
  paymentModeList?: any[];
  viewPageBluPrint: any;
  extraActionsOnRecord?: ExtraRecordLevelActions[];
  platformActionLabels?: platformActionLabelsType[];
  hideActions?: Array<string>;
  enableStepNext?: boolean;
  enableStepSubmit?: boolean;
  enableStepBack?: boolean;
  onStepAction?: Function;
  extraActionsOnRecordCallback?: Function;
  onSuccess?: (value: any) => void;
}

const RecordDetails: React.FC<Props> = ({
  recordId,
  editForm,
  dataApi,
  dataApis,
  urlparams,
  viewPageBluPrint,
  viewApi = getViewApi(dataApis, dataApi, urlparams),
  createApi,
  updateApi,
  isCreateFlow,
  isRelatedInfo,
  setOpen,
  dependantFields,
  userAccessLevel,
  platformAction,
  parentEntity = undefined,
  recordIds,
  loanNos,
  customerNames,
  refreshTable = () => { },
  allowEdits,
  selectedRows,
  moduleCode,
  title,
  dataApiMapper,
  createApiMapper,
  extraActionsOnRecord,
  hideActions,
  platformActionLabels,
  enableStepNext,
  enableStepSubmit,
  enableStepBack,
  onStepAction,
  extraActionsOnRecordCallback,
  onSuccess
}) => {
  const [removedChildForms, setRemovedChildForms] = useState<Map<string, Array<number>>>(new Map());
  const [addedChildForms, setAddedChildForms] = useState<Map<string, Array<number>>>(new Map());
  const [formSchema, setFormSchema] = useState<Field[]>([]);
  const [dynamicFieldCounter, setDynamicFieldCounter] = useState<number>(1);
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [viewData, setViewData] = useState<any>({});
  const [hideEdit, setHideEdit] = useState(false)
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const formFieldsComp = useRef<any>();

  const resetField = (field: string) => {

    const temp = {
      [field]: undefined
    }
  }

  const submitBtn = useRef<any>();

  const setError = (field: string, error: any) => {

    form.setFields([
      {
        name: field, // Field name
        errors: [error.message], // Array of error messages
      }
    ]);
  }

  const [form] = Form.useForm();

  // this doesnt need to take a redux route as its redundant to store in global state.
  const getViewData = (endpoint: string) => {

    if (endpoint && endpoint?.length > 0) {

      if (endpoint.endsWith("/{recordId}") && (urlparams.get("recordId") === null || urlparams.get("recordId") === "" || urlparams.get("recordId") === undefined)) {
        // it indicates that an empty record id is passed from parent component, which we cant use to make a call to api.
        //TODO: the best way to fix this is avoid passing empty record Id from parent or dont send dataApi in blueprint.
        return;
      }

      endpoint = refineApiWithUrlParams(endpoint, urlparams);
      GetRequest(endpoint).then((data) => {
        setViewData(dataTypeHandling(mapViewApiToAliasNames(data, dataApiMapper), editForm));
      });
    }
  };

  // reconverted to redux as this is dependant on table
  const CreateNewRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {
    setSaveLoading(true);
    if (endpoint?.length > 0) {
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {
        let res = await PostRequest(endpoint, data, moduleCode);
        Notification("success", "Saved Successfully");
        refreshTable();
        setOpen(false);
        setSaveLoading(false);

        onSuccess?.(res);
      } catch (err: any) {
        setSaveLoading(false);

        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  // reconverted to redux as this is dependant on table
  const UpdateRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {
    if (endpoint?.length > 0) {
      endpoint = refineApiWithUrlParams(endpoint, urlparams);
      try {
        setSaveLoading(true);
        let res = await PutRequest(endpoint, filterNonUpdatableFields(data, formSchema), moduleCode);
        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);

        setOpen(false);
        onSuccess?.(res);
        setIsEditClicked(false);
      } catch (err: any) {
        setSaveLoading(false);

        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  const renderChildForm = (parentField: ChildForm) => {

    if (parentField.displayType === "panel-labels") {
      return (
        <>
          <Col span={24}>
            <RelatedInfo
              urlparams={urlparams}
              bluprintSections={parentField.detailSections ?? []}
              sectionsBlueprintApis={parentField.relatedInfoBlueprintApi ?? []}
              viewHideEmptyFields={false}
              showSearch={parentField.relatedInfoShowSearch ?? false}
            ></RelatedInfo>
          </Col>
        </>
      );
    }

    return (
      <>
        <Col span={24}>
          <Form.Item>
            <Collapse collapsible="header" defaultActiveKey={["1"]} className={"child-form-collapsible"}>
              <Panel header={parentField.displayName ?? ""} key="1" extra={getAddButtonForChildForm(parentField)}>
                {
                  Array.from(addedChildForms.get(parentField.field) ?? [0]).filter((index) => !(removedChildForms.get(parentField.field) ?? []).includes(index))
                    .map((index) => {
                      return (
                        <div>
                          {getRemoveButtonForChildForm(parentField, index)}
                          <div >
                            {parentField.editFields?.map((field: Field) => {
                              const fieldClone = { ...field, field: parentField.field + "[" + index + "]." + field.field };
                              return (
                                <Col span={6} lg={6} xs={24} style={{ float: "left" }}>
                                  {formFieldsComp.current.exposedMethod(fieldClone)}
                                </Col>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })
                }
              </Panel>
            </Collapse>
          </Form.Item>
        </Col>
      </>
    );
  }

  const getAddButtonForChildForm = (parentField: Field) => (
    <PlusCircleOutlined
      onClick={() => {
        const tempChildForm: Map<string, Array<number>> = new Map(removedChildForms);
        let currentAdded: Array<number> = [...addedChildForms.get(parentField.field) ?? [0]];
        currentAdded.push(currentAdded.length);
        tempChildForm.set(parentField.field, currentAdded);
        setAddedChildForms(tempChildForm);
      }} rev={undefined} />
  );

  const getRemoveButtonForChildForm = (parentField: Field, index: number) => (
    index > 0 ? (
      <>
        <Divider></Divider>
        {(<div className={"remove-icon-childform"}>
          <Form.Item hidden={index === 0} className={"remove-icon-form-item"}>
            <MinusCircleOutlined
              onClick={() => {
                const tempChildForm: Map<string, Array<number>> = new Map(removedChildForms);
                let currentRemoved: Array<number> = [...removedChildForms.get(parentField.field) ?? []];
                currentRemoved.push(index);
                tempChildForm.set(parentField.field, currentRemoved);
                setRemovedChildForms(tempChildForm);
                form.setFieldValue(parentField.field + "[" + index + "]", undefined);
              }} rev={undefined} />
          </Form.Item>
        </div>)}
      </>
    ) : <></>
  );

  const filterReadOnlyFields: any = (data: any) => {

    let editPayload: any = { ...data };
    let readOnlyFields = formSchema
      .filter((x) => !x.editable && x.fieldType !== 'formula').map(({ field }) => field);

    Object.keys(data).forEach((key, index) => {
      if (readOnlyFields.includes(key)) {
        delete editPayload[key];
      }
    });

    return editPayload;
  };

  const onSubmit = (data: any) => {

    data = filterNullValues(data);

    try {
      //default value set for check box 
      formSchema?.forEach((item: any) => {
        if (item && item.fieldType == 'checkBox') {
          data[item.field] = form.getFieldsValue()[item.field]
        }
      });

         // validation check for new info update
         if (data.infoTypeId) {

          if(validationMethod(data)) {
            return true;
          }
        }

      // remove readonly fields in case of edit form
      if (!isCreateFlowRequired()) {
        data = filterReadOnlyFields(data);
      } else {
        data = filterNonCreatableFields(data, formSchema);
      }

      data = mapCreateApiToAliasNames(data, viewData, urlparams, createApiMapper);

      if (data.toBeDepositedAmount) {
        if ((data.depositedAmount > data.toBeDepositedAmount) && Number(data.excessAmount) != (Number(data.depositedAmount) - Number(data.toBeDepositedAmount))) {
          Notification("error", "Invalid Excess Amount");
          return true;
        }
        if ((data.depositedAmount < data.toBeDepositedAmount) && Number(data.shortAmount) != (Number(data.toBeDepositedAmount) - Number(data.depositedAmount))) {
          Notification("error", "Invalid Short Amount");
          return true;
        }
        if (Number(data.toBeDepositedAmount) != Number(data.depositedAmount) + Number(data.shortAmount) - Number(data.excessAmount)) {
          Notification("error", "Invalid Short or Excess Amount");
          return true;
        }
      }

      data = wrapChildEntitiesWithKeys(data);

      //this is to pass unique ids as a part of payload      
      if (recordIds && recordIds.length > 0) {

        if (moduleCode === "systemPis") {
          let paymentMode = ["Q", "P", "D"].includes(selectedRows?.[0]?.paymentMode) ? 'B' : 'C';
          data["paymentMode"] = paymentMode
        } else if (moduleCode === "kPis") {
          data["paymentMode"] = selectedRows?.[0]?.paymentMode;
        } else if (moduleCode === "callsReview" || moduleCode === "visitsReview") {
          data["loanNos"] = loanNos;
          data["customerNames"] = customerNames;
        }

        data["recordIds"] = recordIds;


      } else if (moduleCode === "todo") {
        data["tcCallsId"] = recordId;
      } else if (moduleCode === "fIAllocation") {
        data["leadMstId"] = recordId;
      } else if (moduleCode === "repokitCancelRequest") {
        data["repoKitNo"] = recordId;
      }

      if (parentEntity) {
        let f: any = {};
        f[parentEntity] = [{ ...data }];
        data = f;
      }

      let extraActionButton: ExtraRecordLevelActions | undefined = undefined;

      let buttonActionType = undefined;
      if (submitBtn && submitBtn.current) {

        const clickedButton = submitBtn.current;
        if (clickedButton.value && clickedButton.value !== "") {
          const buttonValue = JSON.parse(clickedButton.value);
          if (buttonValue && buttonValue.actionType === 'javascript') {
            extraActionButton = buttonValue;
          }
          if (buttonValue) {
            buttonActionType = buttonValue.actionType;
          }
        }
      }

      if (extraActionButton) {

        executeExtraAction(recordId, form.getFieldsValue(), urlparams, extraActionButton, refreshTable, setOpen, setError);
      }
      else if (isCreateFlowRequired()) {
        CreateNewRecord(createApi, recordId, data);
        // setIsEditClicked(false);
      } else {
        if ((viewApi !== undefined && viewApi.includes("/composite/")) || (createApi !== undefined && createApi.includes("/composite/"))) {
          UpdateRecord(createApi, recordId, data);
        } else {
          UpdateRecord(updateApi ?? viewApi, recordId, data);
        }
      }

      if (buttonActionType) {
        if (buttonActionType === "stepActionNext") {
          onStepAction && onStepAction(StepAction.NEXT);
        } else if (buttonActionType === "stepActionSubmit") {
          onStepAction && onStepAction(StepAction.SUBMIT);
        }
      }
    }
    catch (e) {
      console.log(e);
    }

  };

  const wrapChildEntitiesWithKeys = (data: any): any => {
    let fileChildEntities = formSchema
      .filter(
        (field) => field.childEntity && field.fieldType === "fileUpload"
      )
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field };
      });

    fileChildEntities.forEach(({ chilldEntity, field }) => {
      if (!data[chilldEntity!]) {
        data[chilldEntity!] = data[field];
        delete data[field];
      }
    });

    let childEntities = [...formSchema]
      .filter((field) => field.childEntity && field.fieldType !== "fileUpload")
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field, iterate: f.iterate ?? false };
      });
    childEntities.forEach(({ chilldEntity, field, iterate }) => {
      let childItems: any = [];
      if (iterate) {
        let multiValuesData: [] = Array.isArray(data[field]) ? data[field] : data[field]?.split(',');
        multiValuesData?.forEach((value) => {
          let item: any = {};
          item[field] = value;
          childItems.push(item);
        });
      } else {
        let childFormData = data[chilldEntity!]?.[0] ?? {};
        childFormData[field] = data[field];
        childItems.push(childFormData);
      }
      data[chilldEntity!] = [...childItems];
    });

    childEntities.forEach(({ chilldEntity, field }) => {
      delete data[field];
    });

    return data;
  };

  const isCreateFlowRequired = (): boolean => {
    return (
      isCreateFlow ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.TRANSFER) ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)
    );
  };

  useEffect(() => {
    if ((getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)) ||
      (getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.EDIT))) {
      setIsEditClicked(true);
    }
  }, [platformAction]);

  useEffect(() => {

    if (
      viewApi?.length > 0 &&
      (!isCreateFlow ||
        getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT) ||
        isRelatedInfo)
    ) {
      getViewData(viewApi);
    }

    if (recordId === '' && moduleCode == 'loanAllocation') {
      const currentDate = moment();
      const formattedDate = currentDate.format('MMM-YY').toLowerCase();
      form.setFieldsValue({ 'allocationMthYr': formattedDate.toString() });
      form.validateFields(['allocationMthYr']);

    }
  }, [viewApi, recordId]);


  useEffect(() => {

    try {

      if (editForm && editForm.length > 0) {

        // //Checking and loading if there are any storefield that need to be pre populated 
        let dataForNewDetailsPage: any;

        let iniState: any = store.getState().initialReducer;

        store.dispatch(deleteDetailsPageData(iniState.reloadDetailsPage.data));

        if (iniState.reloadDetailsPage && iniState.reloadDetailsPage.data.recordId) {
          dataForNewDetailsPage = iniState.reloadDetailsPage.data;
        }

        if (dataForNewDetailsPage && dataForNewDetailsPage !== null) {
          let field: Field = editForm.find((item) => item.field = dataForNewDetailsPage.recordId) as Field;
          form.setFieldValue(dataForNewDetailsPage.recordId, dataForNewDetailsPage[dataForNewDetailsPage.recordId]);
          handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
        }

      }

    } catch (error) {
      console.log(error);
    }

  }, []);

  //TODO: this is a temporary fix need to find a proper way to add grouped fields
  const addGroupFieldBehaviour = () => {

    let editFields = [...formSchema];

    if (
      createApi !==
      "payments/composite/platform/{version}/api/payment-collection-composition"
    ) {
      return;
    }

    let receiptNatureCode = editFields.find(
      (field) => field.field === "receiptNatureCode"
    );

    let receiptNatureAmount = editFields.find(
      (field) => field.field === "receiptNatureAmount"
    );

    let receiptNatureCodeClone = { ...receiptNatureCode } as Field;
    receiptNatureCodeClone.isGroupedField = true;

    let receiptNatureCodeClone1 = { ...receiptNatureCode } as Field;
    receiptNatureCodeClone1.isGroupedField = true;
    receiptNatureCodeClone1!.field = `${receiptNatureCodeClone1?.field}${dynamicFieldCounter}`;

    let receiptNatureAmountClone = { ...receiptNatureAmount } as Field;
    receiptNatureAmountClone.isGroupedField = true;

    let receiptNatureAmountClone1 = { ...receiptNatureAmount } as Field;
    receiptNatureAmountClone1.isGroupedField = true;
    receiptNatureAmountClone1!.field = `${receiptNatureAmountClone1?.field}${dynamicFieldCounter}`;

    let tempForm: Array<Field> = [];

    tempForm = tempForm.concat();
    tempForm = [
      ...editFields
        .filter((field) => field.field !== "receiptNatureAmount")
        .filter((field) => field.field !== "receiptNatureCode"),
    ];
    tempForm.splice(2, 0, receiptNatureCodeClone);
    tempForm.splice(3, 0, receiptNatureAmountClone);
    tempForm.splice(2 + 2 * dynamicFieldCounter, 0, receiptNatureCodeClone1);
    tempForm.splice(3 + 2 * dynamicFieldCounter, 0, receiptNatureAmountClone1);

    setFormSchema(tempForm);
    setDynamicFieldCounter(dynamicFieldCounter + 1);

  };

  const filterFormFields = () => {
    return refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, form.getFieldsValue, form.setFieldValue, resetField, formSchema);
  };

  const getFormSchema = useCallback(() => {

    let formFields = filterFormFields();
    setFormSchema(formFields);

    formFields?.map((field: any) => {
      if (field.fieldType !== "actionButton") {
        setHideEdit(field?.editable)
      }
    });

  }, [editForm]);

  const setInputFieldsValuesObj = () => {

    let tempInputFields: any = {};

    if (formSchema) {
      formSchema?.forEach((item: any) => {
        if (item?.field) {
          tempInputFields[item?.field] = null;
        }
      });
    }

    form.setFieldsValue(tempInputFields);

    if (moduleCode === "systemPis") {
      let totalAmount = 0;
      let paymentMode: any = [];
      selectedRows?.forEach((row: any) => {
        totalAmount = totalAmount + row["receiptAmount"];
        paymentMode.push(row["paymentMode"]);
      });

      handleOnChange(totalAmount.toString(), "totalAmount");

    } else if (moduleCode === "bankPis") {

      let totalAmount = 0;

      selectedRows?.forEach((row: any) => {
        totalAmount = totalAmount + row["spisAmount"];
      });

      form.setFieldsValue({
        depositedAmount: totalAmount.toString(),
        toBeDepositedAmount: totalAmount.toString(),
        shortAmount: "0",
        excessAmount: "0"
      });
    }

    //set default value for checkbox
    formSchema?.forEach((item: any) => {
      if (item && item.fieldType == 'checkBox') {
        form.setFieldValue(item.field, form.getFieldsValue()[item.field] || false);
      }
    });
  };

  useEffect(() => {
    if (formSchema) {
      setInputFieldsValuesObj();
    }
  }, [selectedRows]);


  useEffect(() => {

    form.setFieldsValue(viewData);

    const tempChildForm: Map<string, Array<number>> = new Map(addedChildForms);

    editForm?.filter((field: Field) => field.isChildForm)
      .forEach((field: Field) => {
        if (viewData[field.field]) {
          let currentChildForms: Array<number> = [...addedChildForms.get(field.field) ?? []];
          if (currentChildForms.length >= viewData[field.field].length) {
            return;
          }
          while (currentChildForms.length < viewData[field.field].length) {
            currentChildForms.push(currentChildForms.length);
          }
          tempChildForm.set(field.field, currentChildForms);
        }
      });
    setAddedChildForms(tempChildForm);

    getFormSchema();

  }, [viewData]);

  const [autoFillItems, setAutoFillItems] = useState<any[]>([]);
  const autoCompleteSrc = useRef<any>();
  const [autoCompleteLoading, setAutoCompleteLoading] = useState(false);

  const autoFillCallback = (fieldsToPopulate: any[]) => {

    const temp: any = form.getFieldsValue();
    const validateFields: string[] = [];

    fieldsToPopulate.forEach((field) => {

      let value = field.value;

      if (value) {
        temp[field.field] = value;
        validateFields.push(field.field);
      }
    });

    form.setFieldsValue(temp);
    form.validateFields(validateFields);

    setAutoFillItems([]);
  }

  const handleAutoComplete = (value: any, field: string) => {

    autoCompleteSrc.current = value;

    const CF: any = editForm.find((item) => item.field === field);


    if (CF?.hasOwnProperty('autoCompleteConfig') && CF?.autoCompleteConfig) {

      setAutoCompleteLoading(true);

      if (CF.autoCompleteConfig.requestMethod === 'GET') { }
      else if (CF.autoCompleteConfig.requestMethod === 'POST') {

        const formData = new FormData();

        const headers = {
          'Content-Type': 'multipart/form-data',
        };

        for (let f in CF.autoCompleteConfig.requestMapping) {

          const currentVal = form.getFieldsValue()[CF.autoCompleteConfig.requestMapping[f]];

          // TBD -- Need to handle async behavior here to get value properly from form - can remove else condition then
          if (currentVal !== "" && currentVal !== undefined && currentVal !== null) {
            formData.append(f, currentVal);
          } else {
            formData.append(f, value);
          }
        }

        try {

          PostRequest(CF.autoCompleteConfig.api, formData, undefined, headers).then((res) => {

            const result = res.data.data;
            const responseMapping = CF.autoCompleteConfig.responseMapping;

            let temp: any[] = [];

            for (let key in responseMapping) {

              let tempObj: any = {};
              form.setFieldValue(key, "");

              if (result[responseMapping[key]]) {

                tempObj.label = editForm.find((item) => item.field === key)?.displayName;
                tempObj.value = result[responseMapping[key]];
                tempObj.field = key;

                if (typeof tempObj.value === "number") {
                  tempObj.value = tempObj.value.toString();
                }

                temp.push(tempObj);
              }
            }

            setAutoFillItems(temp);
            setAutoCompleteLoading(false);

          }).catch(() => {
            setAutoCompleteLoading(false);
            setAutoFillItems([]);
            console.log("Error Getting server response");
            Notification('error', "Data could be extraacted from Image");
          });

        } catch {
          setAutoCompleteLoading(false);
          setAutoFillItems([]);
          Notification('error', "Data could be extraacted from Image");
          console.log("Error Getting server response");
        }

      }
    }
  }

  const valueStore = useRef<any>();

  useEffect(() => {

    if (valueStore.current) {
      form.setFieldsValue(valueStore.current);
    }

  }, [formSchema]);

  const handleOnChange = (value: any, field: string, isCheckBox: boolean = false) => {

    if (title === 'User Hierarchy') {
      if (form.getFieldsValue()['ecode'] == value && field == 'reportsTo') {
        form.setFieldValue('reportsTo', '');
        return;
      }
    }

    //Need to store this in ref variable to rerender after formSchema is updated
    const temp = form.getFieldsValue(true)
    temp[field] = value;

    form.setFieldsValue(temp);
    valueStore.current = temp;

    const currentForm = refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, form.getFieldsValue, form.setFieldValue, resetField, formSchema);

    const setValue = (field: string, val: any) => {

      form.setFieldValue(field, val);
      const temp = valueStore.current;
      temp[field] = val;
      valueStore.current = temp;
    }

    refreshFormulaFields(editForm, form.getFieldsValue, setValue, editForm);
    setFormSchema([...currentForm]);

    form.validateFields([field]);

  };

  const handleOnBlur = async (
    value: any,
    field: string,
    lookupField?: string,
    lookupFieldUrl?: string
  ) => {

    if (!lookupField || !lookupFieldUrl || value === "") {
      return;
    }

    handleLoanNumberLookUp(value, lookupField, lookupFieldUrl)
      .then((customerName) => {
        handleOnChange(customerName, lookupField);
      })
      .catch((error) => {

        form.setFields([
          {
            "errors": ["Invalid Loan Number"],
            "name": field,
          }
        ]);
      });
  };

  const handleCascadeOnChange = (value: string, field: string) => {
    // TODO: doesnt work in internet explorer need polyfill
    // api url for cascade fields will be empty handled at client side.
    let indexOfFieldToRefresh = formSchema.findIndex(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    // fetch field from editform as this has the api urls for the cascade fields
    let fieldData = editForm.find(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField == field
    );

    if (
      indexOfFieldToRefresh === -1 ||
      fieldData === null ||
      fieldData === undefined
    ) {
      return;
    }

    let fieldToRefresh = { ...formSchema[indexOfFieldToRefresh] };

    if (viewData[fieldToRefresh.field]) {
      delete viewData[fieldToRefresh.field];
    }

    if (urlparams.has(fieldToRefresh.field)) {
      urlparams.set(fieldToRefresh.field, "");
    }

    // modify api query params based on selection
    let api = fieldData.api;
    let apiWithQueryParams = `${api}&search=${field}:in${value}`;
    fieldToRefresh.api = apiWithQueryParams;

    // update field at certain index
    const newFormSchema = [...formSchema];
    newFormSchema[indexOfFieldToRefresh] = fieldToRefresh;

    // update state with new formfields
    setFormSchema(newFormSchema);
    resetField(fieldToRefresh.field);
  };

  // Reset Fields for edit
  const resetFields = () => {
    if (!isCreateFlow) {
      for (const key in form.getFieldsValue()) {
        if (viewData.hasOwnProperty(key)) {
          const value = viewData[key];
          form.setFieldValue(key, value);
          form.setFieldsValue((preVal: any) => ({
            ...preVal,
            [key]: viewData[key] || ""
          }))
        }
        else {
          form.setFieldsValue({
            [key]: ''
          })
          form.setFieldValue(key, "");
        }
      }
    }
    else {
      for (const key in form.getFieldsValue()) {
        if (form.getFieldsValue().hasOwnProperty(key)) {
          // form.setFieldValue(key, "");
          form.setFieldsValue({})
        }
      }
      if (recordId === '' && moduleCode == '') {
        const currentDate = moment();
        const formattedDate = currentDate.format('MMM-YY').toLowerCase();

        form.setFieldValue('allocationMthYr', formattedDate);
      }
    }
    getFormSchema();
  }


  const renderActions = () => {
    return (
      <>

        {formSchema?.length > 0 &&
          <div className="d-flex mb-3 mt-2 ml-2" style={{ gap: "4px" }}>
            {formSchema?.map((field: Field) => {

              switch (field.fieldType) {
                case "actionButton":
                  return field.actionInfo?.type === "modal" ? (
                    <CustomRecordDetailModal
                      viewPageBluPrint={viewPageBluPrint}
                      title={field
                        .actionInfo?.title ?? ""}
                      platformAction={field.actionInfo?.launchMode}
                      blueprintApi={field.actionInfo?.blueprintApi ?? ""}
                      actionName={field.displayName}
                      isCreateFlow={field.actionInfo?.launchMode === "Create" || field.actionInfo?.launchMode === "CreateWithContext"}
                      userAccessLevel={userAccessLevel}
                      moduleCode={moduleCode}
                      allowEdits={
                        field.actionInfo?.launchMode === "Create" ||
                        field.actionInfo?.launchMode === "CreateWithContext" ||
                        field.actionInfo?.launchMode === "Edit"
                      }
                      urlparams={urlparams}
                    />
                  ) : (
                    <></>
                  );
              }
            })
            }
          </div>}
      </>

    )
  }


  const createEditFields = (): any => {

    if (formSchema) {
      return (
        <>


          <Form form={form} layout="vertical" className="w-100 record-details" onFinish={onSubmit}>

            <div className="text-right">
              {viewPageBluPrint?.hideEmptyFeilds && (<Checkbox checked={selectCheckBox}
                onChange={() => setSelectCheckBox(!selectCheckBox)}>Hide Empty Field</Checkbox>)}
            </div>

            <Row className="mx-auto">
              <InputMethods
                form={form}
                handleOnChange={handleOnChange}
                platformAction={platformAction}
                isEditClicked={isEditClicked}
                isCreateFlow={isCreateFlow}
                editForm={editForm}
                urlparams={urlparams}
                handleOnBlur={handleOnBlur}
                handleCascadeOnChange={handleCascadeOnChange}
                addGroupFieldBehaviour={addGroupFieldBehaviour}
                dependantFields={dependantFields}
                viewData={viewData}
                renderChildForm={renderChildForm}
                selectCheckBox={selectCheckBox}
                formSchema={formSchema}
                ref={formFieldsComp}
                handleAutoComplete={handleAutoComplete}
              />
            </Row>
            {getIndexOfAccessLevel(userAccessLevel) >
              getIndexOfAccessLevelFromVal(AccessLevel.READ) && allowEdits ? (
              footer()
            ) : (
              <></>
            )}
          </Form>

          <>{renderActions()}</>
        </>
      );
    }
  };

  const renderPlatformAction = (actionName: string): boolean | undefined => {
    const criteria = (platformActionLabels?.find(actionLabel => actionLabel.actionName === "Save")?.visibilityCriteria);
    const hideAction: boolean | undefined = (hideActions?.find(action => action === actionName) !== undefined || enableStepNext || enableStepSubmit);
    if (!evaluateCriteria(criteria, editForm, form.getFieldsValue, urlparams) || hideAction) {
      return false;
    }
    return true;
  };

  const footer = () =>

    <>
      <div className="text-right mt-2 record-details">
        {
          (enableStepBack ? (<Button className="button-custom-margin" type="default" onClick={() => onStepAction && onStepAction(StepAction.BACK)}>
            {"Back"}
          </Button>) : (<></>))
        }
        {
          (enableStepNext ? (<Button className="button-custom-margin" type="primary" htmlType="submit" ref={submitBtn} value={JSON.stringify({ "actionType": "stepActionNext" })}>
            {"Save & Continue"}
          </Button>) : (<></>))
        }
        {
          (enableStepSubmit ? (<Button className="button-custom-margin" type="primary" htmlType="submit" ref={submitBtn} value={JSON.stringify({ "actionType": "stepActionSubmit" })}>
            {"Submit"}
          </Button>) : (<></>))
        }

        {
          (isEditClicked || isCreateFlow ? (<>

            {(viewPageBluPrint.resetButton !== true) ? <></> :
              <Button className="button-custom-margin" htmlType="button"
                onClick={() => resetFields()}>
                Reset
              </Button>}

            {!renderPlatformAction("Save") ? <></> :
              <Button className="button-custom-margin" type="primary" htmlType="submit" loading={Boolean(saveLoading)}>
                {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Save")?.label) ?? "Save"}
              </Button>}

            {!renderPlatformAction("Cancel") ? <></> :
              <Button
                className={"btn-1 button-custom-margin " + (isCreateFlow || getIndexOfPlatformAction(platformAction) ===
                  getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT) ? "d-none" : "")}
                type="default"
                onClick={() => setIsEditClicked(false)}
              >
                {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Cancel")?.label) ?? "Cancel"}
              </Button>}
          </>

          ) : (
            !renderPlatformAction("Edit") || getIndexOfAccessLevel(userAccessLevel) < getIndexOfAccessLevelFromVal(AccessLevel.EDIT) ? <></> :
              hideEdit && <Button className="btn-2" type="primary" onClick={() => setIsEditClicked(true)}>
                {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Edit")?.label) ?? "Edit"}
              </Button>
          ))
        }

        {extraActionsOnRecord?.filter(extraAction => evaluateVisibilityOfAction(extraAction, editForm, form.getFieldsValue, urlparams))
          ?.filter(extraAction => extraAction.action ? (getIndexOfPlatformAction(platformAction) ===
            getIndexOfPlatformActionFromVal(extraAction.action)) : true)
          .map(extraAction => {
            if (extraAction.actionType === "modal") {
              return getAction(userAccessLevel, viewPageBluPrint, moduleCode, urlparams, { type: "modal", blueprintApi: extraAction.blueprintApi, title: extraAction.actionName, launchMode: extraAction.launchMode }, extraAction.actionName);
            } else {

              return (<Button className="ml-2 mt-2 btn-3" value={JSON.stringify(extraAction)} htmlType={extraAction.performFormValidation ? "submit" : "button"} ref={submitBtn} type="primary" onClick={(ev) => {

                submitBtn.current = ev.currentTarget || ev.target;

                if (extraActionsOnRecordCallback && extraAction.usePlatformCallback) {
                  extraActionsOnRecordCallback(viewData, extraAction, recordId);
                  setOpen(false);
                } else if (extraAction.performFormValidation) {

                } else {
                  executeExtraAction(recordId, wrapChildEntitiesWithKeys(form.getFieldsValue()), urlparams, extraAction, refreshTable, setOpen, setError);
                }
              }}>
                {extraAction.actionName}

              </Button>);
            }
          })
        }
      </div>

      {autoFillItems.length > 0 && <AutoCompleteHandler srcType="img" src={autoCompleteSrc.current} callback={autoFillCallback} items={autoFillItems}></AutoCompleteHandler>}
      <WholeScreenModal visible={autoCompleteLoading}></WholeScreenModal>

    </>

  return createEditFields();
};

export default React.memo(RecordDetails);
